/*
 * Public API Surface of orders
 */

export * from './lib/orders.service';
export * from './lib/orders.component';
export * from './lib/orders.module';
